import { connect } from 'react-redux';
import { DefaultButton, Text, FontIcon, FontSizes, FontWeights, Label, MessageBarType, Separator } from '@fluentui/react';
import { useEffect, useState } from 'react';
import MOMENT from 'react-moment';
import ProtocolContractFormComponent from '../Protocols/ProtocolContractForm/ProtocolContractFormComponent';
import { useBoolean } from '@fluentui/react-hooks';
import { ErrorMessageComponent } from '../../Error/ErrorMessageComponent';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractToClone } from '../../../models/Entities/Contracts/ContractToClone';

//functions
import * as ComponentFunctions from './ContractHeader.Functions';


////i18Next
import { useTranslation, Trans } from 'react-i18next';

// Styles
import './ContractHeader.Styles.css';
import { useNavigate } from 'react-router-dom';
import { ConfirmationButtonComponent } from '../../../commons/component/ConfirmationButton/ConfirmationButtonComponent';
import { ConfirmationModalComponent } from '../../../commons/component/ConfirmationModal/ConformationModal.Component';
import { CheckmarkCircleRegular, DismissCircleRegular } from '@fluentui/react-icons';



export const ContractHeaderComponent = (props: ComponentFunctions.Props) => {

    const navigate = useNavigate();

    const [selectedContract, setSelectedContract] = useState<Contract | undefined>(undefined);

    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
        useBoolean(false);

    const [Today, setToday] = useState<Date>(new Date());

    const EditContract = () => {
        setSelectedContract(props.Contract);
        openPanel();
    };

    const DeleteContract = (contract: Contract) => {
        props.DeleteContract(contract.id);
        navigate('/contracts/' + (props.Contract?.parentContractId || ''));
    };

    //useTranslation()
    const [t] = useTranslation();


    // Effects
    useEffect(() => {
        props.GetContractById(props.ContractId);
    }, [props.ContractId]);

    // The contract payload carries no concepts, so the verification warning would
    // have nothing to count without this.
    useEffect(() => {
        props.GetAllContractsConcept(props.ContractId, undefined);
    }, [props.ContractId]);

    const isVerified = props.Contract?.contractVerified === true;
    const unapprovedCount = props.UnapprovedConceptCount;

    const VerificationWarning = unapprovedCount !== undefined && unapprovedCount > 0
        ? (unapprovedCount === 1
            ? t('contractHeader.verification.pendingOne')
            : t('contractHeader.verification.pendingMany', { count: unapprovedCount }))
        : '';

    const VerificationPendingShort = unapprovedCount !== undefined && unapprovedCount > 0
        ? t('contractHeader.verification.pendingShort', { count: unapprovedCount })
        : '';

    // Pending concepts warn but never block, so the dialog says so outright
    // instead of leaving the user guessing whether confirming is allowed.
    const VerificationMessage = isVerified
        ? t('contractHeader.verification.removeInfo')
        : VerificationWarning
            ? VerificationWarning + ' ' + t('contractHeader.verification.pendingDoesNotBlock')
            : unapprovedCount === undefined
                ? t('contractHeader.verification.verifyInfoUnknown')
                : t('contractHeader.verification.verifyInfo');

    const handleClosePanel = () => {
        setSelectedContract(undefined);
        dismissPanel();
    };

    const Forms = (<>
        {props.Contract && <ProtocolContractFormComponent
            isOpen={isOpen}
            Contract={selectedContract}
            dismissPanel={handleClosePanel}
            openPanel={openPanel}
            mode=''
            RefererId={undefined}
        />}
    </>
    );

    const Actions = props.Contract && (
        <>
            <div className="ContractActions__Buttons">
                <DefaultButton
                    text={t('contractHeader.actions.edit')}
                    iconProps={{ iconName: 'Edit' }}
                    onClick={EditContract}
                    className='optionButton'
                />

                <ConfirmationButtonComponent
                    ButtonId={"deleteContract" + props.Contract.id}
                    ButtonIconName={"Delete"}
                    ButtonText={t('contractList.contentTable.confirmationButtonDelete.confirm')}
                    ButtonCssClass={""}
                    ConfirmationButtonText={t('contractList.contentTable.confirmationButtonDelete.confirm')}
                    ConfirmationButtonCssClass={"deleteButton"}
                    CancelButtonText={t('contractList.contentTable.confirmationButtonDelete.cancel')}
                    CancelButtonCssClass={""}
                    Title={t('contractList.contentTable.confirmationButtonDelete.deleteContract')}
                    Description={""}
                    ElementTextHeader={t('contractList.contentTable.confirmationButtonDelete.deleteContractInformation') + props.Contract.contractNumber + ' - ' + (props.Contract.parentContractId ? '( Adenda )' : '')}
                    ElementTextInformation={t('contractList.contentTable.confirmationButtonDelete.operationInfo')}
                    onConfirmation={() => DeleteContract(props.Contract!)}
                    onCancel={function (): void {
                        throw new Error('Function not implemented.');
                    }}
                    isOperationExecuting={
                        props.isDeleting
                    }
                    isOperationExecutedWithError={
                        props.failOnDeleting
                    }
                    OperationError={props.error}
                />

            </div>
        </>
    )

    const ErrorSection = props.failOnLoading && props.error && (
        <>
            <ErrorMessageComponent
                Error={props.error}
            />
        </>
    )

    const HeaderContent = (<>
        <div className={"Section ContractStatus " + ComponentFunctions.GetContractStatusClass(props.Contract?.contractStatus) + (isVerified ? ' Reviewed' : '')}>
            <div className="ContractHeader">
                <div className="ContractHeader__Title">
                    <h2 style={{textTransform: 'capitalize'}}>
                        <FontIcon iconName={props.Contract?.isLocked ? 'Lock' : 'Unlock'} style={{
                            color: 'white',
                            paddingTop: '10',
                            fontWeight: FontWeights.bold,
                            fontSize: FontSizes.size14,
                            padding: '.5em .7em',
                            backgroundColor: 'green',
                            marginRight: '.5em',
                            borderRadius: '2em'
                        }} />
                        &nbsp;{props.Contract?.contractNumber}
                        {props.Contract?.parentContractId && <span className='AddendaBadge' >Adenda</span>}
                        {isVerified && (
                            <span className='VerifiedBadge' title={t('contractHeader.verification.verifiedTitle')}>
                                <FontIcon iconName='SkypeCircleCheck' />
                                {t('contractHeader.verification.verified')}
                            </span>
                        )}
                    </h2>
                    <p><Text>{props.Contract?.contractDescription}</Text></p>
                </div>
                <Separator />
                <div className='ContractHeaderDetails'>
                    <div className='ContractMetric'>
                        <span className='ContractMetric__Label'>{t('contractHeader.headerContent.contractStatus')}</span>
                        <span className='ContractMetric__Value'>
                            <span className={'StatusDot ' + ComponentFunctions.GetContractStatusClass(props.Contract?.contractStatus)} />
                            {ComponentFunctions.GetContractStatusDescripcion(props.Contract?.contractStatus)}
                        </span>
                    </div>

                    <div className='ContractMetric'>
                        <span className='ContractMetric__Label'>{t('contractHeader.headerContent.contractCurrency')}</span>
                        <span className='ContractMetric__Value'>
                            {props.Contract?.contractCurrency || t('contractHeader.headerContent.dateNotReported')}
                        </span>
                    </div>

                    {/* Start and end used to share one cell as a bold run of text; split
                        apart they can actually be read and compared at a glance. */}
                    <div className='ContractMetric'>
                        <span className='ContractMetric__Label'>{t('contractHeader.headerContent.validityFrom')}</span>
                        <span className='ContractMetric__Value'>
                            {props.Contract?.contractStartDate ? (
                                <MOMENT format="DD/MM/YYYY">{props.Contract?.contractStartDate}</MOMENT>
                            ) : (
                                <span className='ContractMetric__Empty'>{t('contractHeader.headerContent.dateNotReported')}</span>
                            )}
                        </span>
                    </div>

                    <div className='ContractMetric'>
                        <span className='ContractMetric__Label'>{t('contractHeader.headerContent.validityTo')}</span>
                        <span className='ContractMetric__Value'>
                            {props.Contract?.contractEndDate ? (
                                <MOMENT format="DD/MM/YYYY">{props.Contract?.contractEndDate}</MOMENT>
                            ) : (
                                <span className='ContractMetric__Empty'>{t('contractHeader.headerContent.dateNotReported')}</span>
                            )}
                        </span>
                        {props.Contract?.contractEndDate && (
                            <span className='ContractMetric__Note'>
                                {t('contractHeader.headerContent.expiration')}&nbsp;
                                <MOMENT to={props.Contract?.contractEndDate} unit="days">{Today}</MOMENT>
                            </span>
                        )}
                    </div>

                    <div className='ContractMetric ContractMetric--verification'>
                        <span className='ContractMetric__Label'>{t('contractHeader.verification.label')}</span>
                        <div className='VerificationRow'>
                            <span className={isVerified ? 'VerificationState Verified' : 'VerificationState Pending'}>
                                <FontIcon iconName={isVerified ? 'SkypeCircleCheck' : 'AlertSolid'} />
                                {isVerified
                                    ? t('contractHeader.verification.verified')
                                    : t('contractHeader.verification.notVerified')}
                            </span>
                            {VerificationPendingShort && (
                                <span className='VerificationPending' title={VerificationWarning}>
                                    {VerificationPendingShort}
                                </span>
                            )}
                            <div className='VerificationAction'>
                            <ConfirmationModalComponent
                                onConfirm={() => props.SetContractVerified(props.Contract!.id, !isVerified)}
                                onDismiss={() => undefined}
                                title={isVerified
                                    ? t('contractHeader.verification.removeTitle')
                                    : t('contractHeader.verification.verifyTitle')}
                                message={VerificationMessage}
                                buttonApparence={isVerified ? 'subtle' : 'primary'}
                                buttonShape={'circular'}
                                buttonTitle={isVerified
                                    ? t('contractHeader.verification.removeAction')
                                    : t('contractHeader.verification.verifyAction')}
                                buttonIcon={isVerified ? <DismissCircleRegular /> : <CheckmarkCircleRegular />}
                                isProcessing={props.isSettingVerified}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='ContractActions'>
                {props.Contract && Actions}
            </div>
        </div>
    </>
    );


    return (
        <>
            {ErrorSection}
            {HeaderContent}
            {Forms}
        </>
    );

}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(ContractHeaderComponent as any);